import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Loader2, Mail } from 'lucide-react';
import api from '../../services/api';
import { successAlert } from '../../utils/alerts';
import AuthLayout from './AuthLayout';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      const response = await api.post('/auth/password-reset/', { email });
      setSent(true);
      await successAlert(
        'Verifique seu e-mail',
        response.data?.detail || 'Se o e-mail estiver cadastrado, você receberá instruções para redefinir sua senha.'
      );
    } catch (err) {
      // A API sempre retorna 200, mas tratamos falhas de rede de forma silenciosa
      setSent(true);
      await successAlert(
        'Verifique seu e-mail',
        'Se o e-mail estiver cadastrado, você receberá instruções para redefinir sua senha.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title="Esqueci minha senha">
      <p className="text-sm text-gray-500 mb-6">
        Informe seu e-mail cadastrado e enviaremos um link para redefinir sua senha.
      </p>

      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1.5">
            E-mail
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <Mail className="h-5 w-5 text-gray-400" />
            </div>
            <input
              id="email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Digite seu e-mail"
              autoComplete="email"
              className="w-full pl-10 pr-4 py-2.5 bg-gray-50/50 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/40 focus:border-blue-500 focus:bg-white transition-all"
              disabled={loading || sent}
            />
          </div>
        </div>

        <button
          type="submit"
          disabled={loading || sent}
          className="w-full py-3.5 px-4 bg-[#1e3a5f] hover:bg-[#162d49] active:bg-[#12253d] text-white font-semibold rounded-xl shadow-md shadow-blue-900/20 hover:shadow-lg hover:shadow-blue-900/30 transition-all duration-200 disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center gap-2"
        >
          {loading ? (
            <>
              <Loader2 size={18} className="animate-spin" />
              Enviando...
            </>
          ) : sent ? (
            'E-mail enviado'
          ) : (
            'Enviar link de redefinição'
          )}
        </button>
      </form>

      <div className="mt-6 text-center">
        <Link
          to="/login"
          className="text-sm text-blue-600 hover:text-blue-800 hover:underline transition-colors font-medium"
        >
          Voltar ao login
        </Link>
      </div>
    </AuthLayout>
  );
};

export default ForgotPassword;
